import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Button,
  darken,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";
import ojieCry3xIcon from "@assets/icons/ojie-cry@3x.png";

const useStyles = makeStyles()((theme) => ({
  manageSubscriptionButton: {
    flexShrink: 0,
    marginLeft: "auto",
  },
  suspendedDialog: {
    minWidth: 1255,
    backgroundColor: "#FF6262",
    color: colors.white,
  },
  suspendedDialogContent: {
    padding: theme.spacing(0, 8, 8),
  },
  suspendedDialogHead: {
    display: "flex",
    justifyContent: "flex-end",
  },
  suspendedDialogTitle: {
    margin: theme.spacing(5, 0, 7),
    fontSize: "1.75rem",
  },
  suspendedDialogDescription: {
    marginBottom: theme.spacing(7),
    fontWeight: 600,
    fontSize: 12,
    lineHeight: 1.25,
  },
  suspendedDialogButton: {
    marginBottom: theme.spacing(8),
    backgroundColor: "#0B1B26",
    color: colors.white,
    "&:hover": {
      backgroundColor: darken("#0B1B26", 0.2),
    },
  },
}));

interface SuspendedDialogProps {
  isVisible: boolean;
  onClose: () => void;
}

const SuspendedDialog: React.FC<SuspendedDialogProps> = ({
  isVisible,
  onClose,
}) => {
  const { classes } = useStyles();

  return (
    <Dialog
      classes={{ paper: classes.suspendedDialog }}
      open={isVisible}
      onClose={onClose}
    >
      <DialogTitle className={classes.suspendedDialogHead}>
        <IconButton
          aria-label="close"
          color="inherit"
          onClick={onClose}
          size="small"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.suspendedDialogContent}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <img src={ojieCry3xIcon} alt="Payment Failed" />
          <Typography className={classes.suspendedDialogTitle} variant="h4">
            Payment Failed
          </Typography>
          <Typography className={classes.suspendedDialogDescription}>
            Please settle your account subscription as soon as possible to
            continue your full access to the NutriCoach application.
          </Typography>
          <Button
            className={classes.suspendedDialogButton}
            component={NavLink}
            to="/subscription"
          >
            Manage subscription
          </Button>
          <Typography variant="caption">For concerns, Contact Us.</Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SuspendedDialog;
